export default "__VITE_PUBLIC_ASSET__a6d2bfc2__"